import type { ConfigType } from 'dayjs';
import dayjs from 'dayjs';

export const getIntervalFrequency = (value: ConfigType): number => {
	if (dayjs().diff(value, 'hour')) {
		return 300000; // update every 5 minutes
	}

	return 10000; // update every 10 seconds
};
